import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute, redirect } from "@tanstack/react-router";
import { lazy } from "react";
import { parseGapsSearch } from "./gaps-view";
import { parseLedgerSearch } from "./overview";

const LedgerPage = lazy(() =>
	import("./pages/ledger.page").then((m) => ({ default: m.LedgerPage })),
);
const GapsPage = lazy(() => import("./pages/gaps.page").then((m) => ({ default: m.GapsPage })));
const SessionPage = lazy(() =>
	import("./pages/session.page").then((m) => ({ default: m.SessionPage })),
);

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/ledger",
		component: LedgerPage,
		// Filters live in the URL (?range=30d&harness=claude&repo=a,b&q=…) so a
		// view is shareable.
		validateSearch: parseLedgerSearch,
		// Legacy links opened the old gaps drawer with ?gaps=true; send them to the
		// page. Reads the raw query string, since the validated search no longer
		// knows `gaps`. The overview's range/repo params don't apply there.
		beforeLoad: ({ location }) => {
			if (new URLSearchParams(location.searchStr).get("gaps") === "true")
				throw redirect({ to: "/ledger/gaps" });
		},
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/ledger/gaps",
		component: GapsPage,
		// ?kind=unpriced&harness=codex&q=… — defaults are omitted.
		validateSearch: parseGapsSearch,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/ledger/sessions/$id",
		component: SessionPage,
	}),
];
